import { Routes } from '@angular/router';
import { AuthGuard } from '../_guards/auth.guard';
import { QuickBooksSyncAdminComponent } from './quickbooks-sync-admin.component';

export const QuickBooksSyncAdminRoutes: Routes = [
  {
    canActivate: [AuthGuard],
    path: 'quickBooksSync',
    component: QuickBooksSyncAdminComponent,
    data: { roles: 'SystemAdministrator', title: 'סנכרון QuickBooks' }
  }
];
